/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const COMMERCE_AI_REGION_URL_KEY = 'hcl.commerceAI.regionURL';
export const COMMERCE_AI_PROJECT_KEY = 'hcl.commerceAI.projectExtKey';
export const COMMERCE_AI_SUBSCRIPTION_KEY = 'hcl.commerceAI.subscriptionKey';
export const COMMERCE_AI_HEADER_SUBSCRIPTION_KEY = 'Subscription-Key';
